import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory as history } from 'react-router';
import moment from "moment";

import JibeSummery from '../../../../components/v3/CalibrationScreenV3/JibeSummery';
import TeamsTableForManager from './teams/TeamsTableForManager';
import TeamAgentsTableForManager from './teams/TeamAgentsTableForManager';
import CalibrationV3AgentScreen from '../agents/CalibrationV3AgentScreen';
import CalibrationV3SupervisorScreen from '../supervisor/CalibrationV3SupervisorScreen';
import TeamsCompareAndOverTimeGraphs from './graphs/TeamsCompareAndOverTimeGraphs';

import { pageLoaded } from '../../../../utils';
import { ZRole } from '../../../../generated';

import {
    updateProps,
    loadJibeManagerScreen,
    loadProgressOverTimeStats,
    loadTeamAgentsJibeStats,
} from '../CalibrationV3ScreenActions';
import { arrayIsNotEmpty, getQuestionColor, isDefined } from '../../../../utils';

class CalibrationV3ManagerScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTeamId: -1,
            showTeamAgentsPopup: false,
        };

        this.onSelectAgent = this.onSelectAgent.bind(this);
        this.onSelectNewTimeRange = this.onSelectNewTimeRange.bind(this);

        this.closeTeamAgentsPopup = this.closeTeamAgentsPopup.bind(this);
        this.showTeamAgentsPopup = this.showTeamAgentsPopup.bind(this);

        this.getSurveyCountSummaryNode = this.getSurveyCountSummaryNode.bind(this);
    }

    componentDidMount() {
        pageLoaded('Jibe');
        this.props.dispatch(loadJibeManagerScreen());
    }

    showTeamAgentsPopup(teamId) {
        this.props.dispatch(loadTeamAgentsJibeStats(teamId, 1, 2));
        this.setState({
            selectedTeamId: teamId,
            showTeamAgentsPopup: true,
        });
    }

    closeTeamAgentsPopup(e) {
        this.setState({
            selectedTeamId: -1,
            showTeamAgentsPopup: false,
        });
        this.props.dispatch(updateProps({ currentTeamAgentsCalibrationStats: undefined }));
    }

    onSelectAgent(userId) {
        const
            {
                currentTeamAgentsCalibrationStats,
            } = this.props;
        if (!isDefined(currentTeamAgentsCalibrationStats)) {
            return;
        }

        this.props.dispatch(updateProps({ currentTeamAgentsCalibrationStats: undefined }));
        const selectedAgent = currentTeamAgentsCalibrationStats.find(a => a.id === userId);
        this.props.dispatch(updateProps({ selectedAgent: selectedAgent }));
        history.push(`/Jibe/status/agent/${userId}`);
    }

    onSelectNewTimeRange(fromDate, toDate, selectedTimePeriodicity) {
        this.props.dispatch(updateProps({ progressOverTimeStats: undefined }));
        this.props.dispatch(loadProgressOverTimeStats(fromDate, toDate, selectedTimePeriodicity));
    }

    getSurveyCountSummaryNode() {
        const
            {
                teamsCalibrationStats,
                calibratedOnSurveyQuestions
            } = this.props;
        if (!isDefined(teamsCalibrationStats) || !isDefined(calibratedOnSurveyQuestions)) {
            return (<div className="system-dashboard-jibe-border SurveyCountSummery-main"
                style={{ padding: '24px 24px 0 24px', backgroundImage: `url(${`../../../../../Assets/Images/V3Design/profileAgentNoAvatar.png`})` }}>
                <div className="flex-container" style={{ minHeight: '38px', borderBottom: '1px solid #E6F7F8', }}>
                    <div className="title-primary-400-24-28">
                        Jibe Summary
                    </div>
                </div>
                <div style={{ minHeight: '101px', marginLeft: '45px' }}>
                    <div>
                        <img src="../../../../../Assets/Images/V3Design/Zac.gif" width="163" />
                    </div>
                </div>

            </div >)
        }

        const allTeamsData = teamsCalibrationStats.filter(t => t.aggregationName === "All Teams");

        let totalCount;
        let jibeSummery = [];
        if (arrayIsNotEmpty(allTeamsData)) {
            jibeSummery = calibratedOnSurveyQuestions.map(qc => {
                const questionData = allTeamsData.find(t => t.questionCode == qc.questionCode);
                return {
                    text: qc.nameForClient,
                    barColor: getQuestionColor(questionData.questionCode),
                    number: isDefined(questionData) ? questionData.overalSuccessRatePercent : undefined,
                }
            });
            totalCount = allTeamsData[0].sessionCnt;
        }

        return (<JibeSummery jibeSessions={totalCount} surveySummery={jibeSummery} />);
    }

    render() {
        const
            {
                teamsCalibrationStats,
                progressOverTimeStats,
                calibratedOnSurveyQuestions,
                currentTeamAgentsCalibrationStats,
                currentUser,
            } = this.props;
        if (!currentUser) {
            return <div>
                <img src="../../../../../Assets/Images/V3Design/Zac.gif" width="250" />
            </div>;
        }
        if (currentUser.RoleId == ZRole.Agent) {
            return <CalibrationV3AgentScreen />
        }
        else if (currentUser.RoleId == ZRole.Supervisor) {
            return <CalibrationV3SupervisorScreen />;

        }

        const surveyCountSummaryNode = this.getSurveyCountSummaryNode();

        return (
            <div className="main-page-width">
                <div className="flex-container" style={{ margin: '20px 0px 3px 0' }}>
                    {surveyCountSummaryNode}
                </div>
                <TeamsCompareAndOverTimeGraphs
                    teamsCalibrationStats={teamsCalibrationStats}
                    progressOverTimeStats={progressOverTimeStats}
                    onSelectNewTimeRange={this.onSelectNewTimeRange} />
                <br />
                {this.state.showTeamAgentsPopup &&
                    (<TeamAgentsTableForManager
                        onSelectAgent={(userId) => this.onSelectAgent(userId)}
                        selectedTeam={currentTeamAgentsCalibrationStats}
                        calibratedOnSurveyQuestions={calibratedOnSurveyQuestions}
                        onClose={this.closeTeamAgentsPopup} />)}
                <br />
                <TeamsTableForManager onClick={(teamId) => this.showTeamAgentsPopup(teamId)} />
                <br />
                <br />
            </div >);
    }
}

const select = state => ({ ...state.CalibrationV3Screen, ...state.session });

export default connect(select)(CalibrationV3ManagerScreen);